const MENU_WIDTH = 335;

const getElemPosition = (elem, iframeRef) => {
    const height = elem.offsetHeight;
    let box = elem.getBoundingClientRect();
    const iframeDocument = iframeRef.current.contentDocument || iframeRef.current.contentWindow?.document;

    let body = iframeDocument.body;
    let docEl = iframeDocument.documentElement;

    let scrollTop = iframeRef.current.contentWindow.pageYOffset || docEl.scrollTop || body.scrollTop;
    let scrollLeft = iframeRef.current.contentWindow.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    let clientTop = docEl.clientTop || body.clientTop || 0;
    let clientLeft = docEl.clientLeft || body.clientLeft || 0;

    let top  = box.top +  scrollTop - clientTop;
    let left = box.left + scrollLeft - clientLeft;

    return { top: Math.round(top) + height, left: Math.round(left) };
};

export const getPosition = (elem, iframeRef) => {
    let box = typeof elem.getBoundingClientRect === "function" ? elem.getBoundingClientRect() : elem.target.getBoundingClientRect();
    const { body } = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;

    const element = elem.target && elem.target !== "_blank" ? elem.target : elem;
    let position = getElemPosition(element, iframeRef);

    if((body.clientWidth - box.right) < MENU_WIDTH){
        position = { ...position, left: position.left - (MENU_WIDTH - box.width) };
    }

    return position;
};
